// Modals are imported directly here due to a circular dependency.

/* Components */
import { Modal } from 'application/Shared/Modals/Components/Modal';

/* Hooks */
import { usePostTagSettings } from 'hooks/dataAccess/GlobalTag/tagSettings';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

/* Components */
import { AddNewTagModalBody } from './AddNewTag';

const createTagAndSetting = async ({
    name,
    description,
    color,
    platformTenantId,
    postTagSettings,
    onClose,
    onSuccessFn
}) => {
    const success = await postTagSettings({
        color,
        description,
        name,
        platformTenantId
    });

    if (success) {
        onSuccessFn();
        onClose();
    }
};

export const AddTagModal = ({
    onClose,
    open,
    tagDefaultValues,
    onSuccessFn = () => {}
}) => {
    const { t } = useTranslation();

    const isEditing = !!tagDefaultValues;

    const { postTagSettings } = usePostTagSettings();

    const { partnerId, clientId } = useParams();
    const platformTenantId = clientId || partnerId;

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={
                isEditing
                    ? t('AddTagModal.title.edit')
                    : t('AddTagModal.title.create')
            }
            paperProps={{
                minWidth: ['400px', '720px'],
                width: '600px'
            }}
        >
            <AddNewTagModalBody
                isEditing={isEditing}
                onClose={onClose}
                tagDefaultValues={tagDefaultValues}
                onCreate={({ name, color, description }) =>
                    createTagAndSetting({
                        color,
                        description,
                        name,
                        onClose,
                        onSuccessFn,
                        platformTenantId,
                        postTagSettings
                    })
                }
            />
        </Modal>
    );
};
